import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@ngneat/transloco';

import { CreateMessageComponent } from './create-message/create-message.component';
import { MessagesListComponent } from './list/messages-list.component';
import { MessagesComponent } from './messages.component';
import { DTypeModule } from '../../../core/dtype/dtype.module';
import { SharedModule } from '../../../shared/shared.module';

@NgModule({
    declarations: [
        CreateMessageComponent,
        MessagesComponent,
        MessagesListComponent,
    ],
    imports: [
        DTypeModule,
        RouterModule,
        OverlayModule,
        PortalModule,
        SharedModule,
        TranslocoModule,
    ],
    exports: [
        CreateMessageComponent,
        MessagesComponent
    ]
})
export class MessagesModule { }
